import axios from 'axios'

export const WILL_GET_INCOME_STATEMENT_ANNUAL = 'WILL_GET_INCOME_STATEMENT_ANNUAL'
export const GET_INCOME_STATEMENT_ANNUAL_SUCCESS = 'GET_INCOME_STATEMENT_ANNUAL_SUCCESS'
export const GET_INCOME_STATEMENT_ANNUAL_FAILURE = 'GET_INCOME_STATEMENT_ANNUAL_FAILURE'

export const WILL_GET_INCOME_STATEMENT_QUATERLY = 'WILL_GET_INCOME_STATEMENT_QUATERLY'
export const GET_INCOME_STATEMENT_QUATERLY_SUCCESS = 'GET_INCOME_STATEMENT_QUATERLY_SUCCESS'
export const GET_INCOME_STATEMENT_QUATERLY_FAILURE = 'GET_INCOME_STATEMENT_QUATERLY_FAILURE'


export const getIncomeStatementAnnual = (symbol, signal) => {
    return (dispatch) => {
        dispatch({
            type: WILL_GET_INCOME_STATEMENT_ANNUAL
        })
        axios.get(`https://financialmodelingprep.com/api/v3/financials/income-statement/${symbol}`, { cancelToken: signal.token })
            .then(response => {
                return dispatch({
                    type: GET_INCOME_STATEMENT_ANNUAL_SUCCESS,
                    data: response.data.financials
                })
            }).catch(error => {
                return dispatch({
                    type: GET_INCOME_STATEMENT_ANNUAL_FAILURE
                })
            })
    }
}

export const getIncomeStatementQuaterly = (symbol, signal) => {
    return (dispatch) => {
        dispatch({
            type: WILL_GET_INCOME_STATEMENT_QUATERLY
        })
        axios.get(`https://financialmodelingprep.com/api/v3/financials/income-statement/${symbol}?period=quarter`, { cancelToken: signal.token })
            .then(response => {
                return dispatch({
                    type:GET_INCOME_STATEMENT_QUATERLY_SUCCESS,
                    data: response.data.financials
                })
            }).catch(error => {
                return dispatch({
                    type: GET_INCOME_STATEMENT_QUATERLY_FAILURE
                })
            })
    }
}